import { __rest } from "tslib";
import firebase from "firebase/app";
import { writable } from "svelte/store";
import { userStore } from "./auth";
import { produce } from "immer";
export const validateCrypto = async (source) => {
    return firebase
        .functions()
        .httpsCallable("validateCryptoAddress")(source)
        .then((a) => a.data);
};
export const validateExchangeRate = async (currency, coin) => {
    return firebase
        .functions()
        .httpsCallable("validateExchangeRate")({
        currency,
        coin,
    })
        .then((a) => { var _a; return (_a = a.data) === null || _a === void 0 ? void 0 : _a.valid; });
};
export const createJob = async ({ budgetId, accountId, address, symbol, currency, }) => {
    return firebase.functions().httpsCallable("create")({
        budgetId,
        accountId,
        address,
        symbol,
        currency,
    });
};
export const deleteJob = async (jobId) => {
    return firebase.firestore().doc(`jobs/${jobId}`).delete();
};
export const runJobImmediatelly = async (jobId) => {
    return firebase.functions().httpsCallable("runJob")({ jobId });
};
const jobConverter = {
    toFirestore(_a) {
        var { id } = _a, job = __rest(_a, ["id"]);
        return job;
    },
    fromFirestore(snapshot) {
        var _a;
        const raw = snapshot.data();
        if (raw === null || raw === void 0 ? void 0 : raw.lastRun) {
            raw.lastRun = raw.lastRun.toDate();
        }
        if (raw === null || raw === void 0 ? void 0 : raw.nextRun) {
            raw.nextRun = raw.nextRun.toDate();
        }
        if ((_a = raw === null || raw === void 0 ? void 0 : raw.runNowQuota) === null || _a === void 0 ? void 0 : _a.date) {
            raw.runNowQuota.date = raw.runNowQuota
                .date.toDate();
        }
        raw.id = snapshot.id;
        return raw;
    },
};
export const createJobStore = () => {
    let jobListenerUnsubscribe;
    const { update, subscribe, set } = writable({});
    userStore.subscribe((user) => {
        if (user) {
            jobListenerUnsubscribe = firebase
                .firestore()
                .collection("jobs")
                .withConverter(jobConverter)
                .where("userId", "==", user.uid)
                .onSnapshot((snap) => {
                update((prev) => {
                    return produce(prev, (draft) => {
                        snap.docChanges().forEach((change) => {
                            switch (change.type) {
                                case "modified":
                                    if (draft[change.doc.id]) {
                                        Object.assign(draft[change.doc.id], change.doc.data());
                                        break;
                                    }
                                case "added":
                                    draft[change.doc.id] = change.doc.data();
                                    break;
                                case "removed":
                                    delete draft[change.doc.id];
                                    break;
                                default:
                            }
                        });
                    });
                });
            });
        }
        else if (jobListenerUnsubscribe) {
            set({});
            jobListenerUnsubscribe();
            jobListenerUnsubscribe = null;
        }
    });
    return {
        subscribe,
    };
};
